import React from 'react';
import PropTypes from 'prop-types';
import api from 'api';
import Component from 'BaseComponent';
import { notice, alert } from 'ducks/notifications';
import { reduxForm, getFormValues } from 'redux-form';
import validators from 'utils/validators';
import generateFormValidation from 'utils/generateFormValidation';
import convertToFormErrors from 'utils/convertToFormErrors';
import { withRouter } from 'react-router-dom';
import Field from 'form/Field';
import Form from 'form/Form';
import { connect } from 'react-redux';
import SubmitButton from 'form/SubmitButton';
import Select from 'form/Select';

@withRouter

@connect((state, props) => ({
  initialValues: props.site.attributes,
  formValues: getFormValues('ServerSettings')(state),
}))

@reduxForm({
  form: 'ServerSettings',
  validate: generateFormValidation({
    phpVersion: [validators.required()],
    modPagespeedRewriteLevel: [validators.required()],
  }),
  onSubmit(values, dispatch, props) {
    const { site } = props;

    return dispatch(api.updateSite(
      { id: site.id },
      {
        data: {
          type: 'site',
          attributes: values,
        },
      },
    ))
    .then(() => {
      props.history.push(`/site/${site.id}/settings`);
      dispatch(notice('ServerSettings.success'));
    })
    .catch((response) => {
      dispatch(alert('ServerSettings.error'));
      return Promise.reject(convertToFormErrors(response));
    });
  },
})

export default class ServerSettings extends Component {

  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    dirty: PropTypes.bool.isRequired,
    error: PropTypes.string,
    site: PropTypes.object.isRequired,
    formValues: PropTypes.object,
  }

  render() {
    const { site, handleSubmit, submitting, error, dirty, formValues } = this.props;

    return (
      <div className="Site__area">
        <div className="Site__area__header">
          <div className="Site__area__header__title">
            WP Server settings
            <br />
            (need WP restart)
          </div>
        </div>
        <div className="Site__area__content">
          <Form error={error} onSubmit={handleSubmit}>
            <Field label="Settings.phpVersion" name="phpVersion">
              { site.attributes.k8s ?
                <Select
                  clearable={false}
                  options={[
                    { value: '8.1', label: '8.1' },
                    { value: '7.4', label: '7.4' },
                    { value: '7.3', label: '7.3' },
                    { value: '7.2', label: '7.2' },
                    { value: '7.1', label: '7.1' },
                    { value: '7.0', label: '7.0' },
                    { value: '5.6', label: '5.6' },
                  ]}
                />
                :
                <Select
                  clearable={false}
                  options={[
                    { value: '5.6', label: '5.6' },
                    { value: '7.0', label: '7.0' },
                  ]}
                />
              }
            </Field>
            <Field label="Settings.modPagespeedRewriteLevel" name="modPagespeedRewriteLevel">
              <Select
                clearable={false}
                options={[
                  { value: 'off', label: 'Off' },
                  { value: 'OptimizeForBandwidth', label: 'OptimizeForBandwidth' },
                ]}
              />
            </Field>
            { formValues && formValues.modPagespeedRewriteLevel === 'OptimizeForBandwidth' &&
              <div className="Settings__area__server">
                <div>
                  In this mode, PageSpeed does not alter HTML at all.
                  It compresses and transcodes images in place, and minifies JavaScript and CSS.
                  By avoiding changes to URL syntax and to HTML,
                  the potential problem of user-written JavaScript encountering
                  unexpected DOM elements is elimimated.
                  There is still latency benefit due to the reduced size of resources,
                  as well as substantial bandwidth reduction.
                  <div><a href="https://www.modpagespeed.com/doc/optimize-for-bandwidth" target="_blank" rel="noopener noreferrer">Read more</a></div>
                </div>
              </div>
            }
            { formValues && formValues.modPagespeedRewriteLevel === 'CoreFilters' &&
              <div className="Settings__area__server">
                <div>
                  CoreFilters is designed to reduce latency,
                  incurring a small risk of page breakage.
                  The core set of filter contains:
                  <br />
                  <i>
                    add_head,
                    combine_css,
                    combine_javascript,
                    convert_meta_tags,
                    extend_cache,
                    fallback_rewrite_css_urls,
                    flatten_css_imports,
                    inline_css,
                    inline_import_to_link,
                    inline_javascript,
                    rewrite_css,
                    rewrite_images,
                    rewrite_javascript,
                    rewrite_style_attributes_with_url.
                  </i>
                  <div><a href="https://www.modpagespeed.com/doc/config_filters" target="_blank" rel="noopener noreferrer">Read more</a></div>
                </div>
              </div>
            }
            <Field label="Settings.basicAuthEnabled" name="basicAuthEnabled">
              <input type="checkbox" defaultChecked={site.attributes.basicAuthEnabled} />
            </Field>
            <SubmitButton
              dirty={dirty}
              className="button button--secondary"
              submitting={submitting}
              label="Settings.submit"
            />
          </Form>
        </div>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./app/components/ServerSettings.jsx